import { z } from "zod";
/**
 * The ONE registry-office validation, shared by every door (CLAUDE.md §2A: "the
 * same zod/schema validation at the admin form and the importer as everywhere
 * else"). The web form, the API route, and the bulk importer all parse against
 * this exact schema — there is no second, laxer path for operators. A registry
 * boundary that does not parse is rejected at entry, never silently stored.
 *
 * Provenance is deliberately NOT in this schema. `sourced_by` (the admin) and
 * `sourced_at` are set server-side from the authenticated principal — never
 * accepted from the form or the import file, because "who entered this" must be
 * the actual actor, not a value the actor can type. `source` (what the data came
 * from — "RGD gazette 2026/14") IS operator-provided and required: an office with
 * no stated source is refused, matching the database's NOT NULL on that column.
 */
const trimmedNonEmpty = (max) => z.string().trim().min(1).max(max);
export const registryOfficeInputSchema = z.object({
    /**
     * The stable routing key. Uppercase alphanumerics, hyphens and slashes — the
     * shape of an RGD office code (e.g. "COL-01"). It is referenced by
     * cases.registry_district, so it must be stable and machine-safe, not free text.
     */
    code: z
        .string()
        .trim()
        .min(1)
        .max(32)
        .regex(/^[A-Z0-9][A-Z0-9/-]*$/, "code must be uppercase letters, digits, hyphens or slashes"),
    name: trimmedNonEmpty(200),
    /** The routing key routing.ts matches a parcel's district against. Required. */
    district: trimmedNonEmpty(100),
    province: z.string().trim().max(100).optional(),
    active: z.boolean().default(true),
    /**
     * What the data came from. Required and non-empty — the honesty guarantee that
     * no office enters the table without a stated origin. Rejected at the form, and
     * independently by the database's NOT NULL constraint.
     */
    source: trimmedNonEmpty(300),
});
/** An edit cannot change the code (it is the FK routing key). Everything else is editable. */
export const registryOfficeUpdateSchema = registryOfficeInputSchema.omit({ code: true }).partial();
//# sourceMappingURL=registry-validation.js.map